import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
  width: 120px;
  word-wrap: break-word;
  color: var(--text-default);
`;

export const Root = styled.div`
  width: 100%;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
